import React from "react";
import StatisticsCard from "../../components/Card/StatisticsCard";
import userImg from "../../assets/cardUsers.svg";
import totalPartnership from "../../assets/totalPartnership.svg";
import acceptancePart from "../../assets/acceptancePart.svg";
import { getStatisticsDataAPI } from "../../API/DashboardAPI/AdminAPI";
import { useQuery } from "@tanstack/react-query";
import ButtonLoader from "../../components/button/ButtonLoader";
import Wrapper from "../../components/wrapper/Wrapper";

const Dashboard = () => {
  const {
    data: DashData,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["users"],
    queryFn: getStatisticsDataAPI,
  });

  if (error) return <div>Error: {error.message}</div>;
  if (isLoading) {
    return (
      <div className="py-10 w-full flex justify-center items-center">
        <ButtonLoader />
      </div>
    );
  }

  return (
    <Wrapper>
      <div className="flex justify-evenly items-center gap-1 flex-col xl:flex-row">
        <StatisticsCard
          img={userImg}
          url={""}
          title={"Total Users"}
          value={DashData?.data.totalUsers}
        />
        <StatisticsCard
          img={totalPartnership}
          url={""}
          title={"Total partnerShipsCount"}
          value={DashData?.data.partnerShipsCount}
        />
        <StatisticsCard
          img={acceptancePart}
          url={""}
          title={"Partnership Accepted"}
          value={DashData?.data.partnerShipAccepted}
        />
      </div>
    </Wrapper>
  );
};
export default Dashboard;
